import { render, staticRenderFns } from "./FalseDashboard.vue?vue&type=template&id=68e3f902&scoped=true&"
import script from "./FalseDashboard.vue?vue&type=script&lang=js&"
export * from "./FalseDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FalseDashboard.vue?vue&type=style&index=0&id=68e3f902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e3f902",
  null
  
)

export default component.exports